export default function(property = '', key = 'id', defaultState = false) {
  return {
    data() {
      return {
        checkbox$selection: [],
        checkbox$all: false,
        checkbox$indeterminate: false,
      }
    },
    computed: {
      checkbox$header() {
        return {
          'checked': this.checkbox$all,
          'indeterminate': this.checkbox$indeterminate,
          'disabled': this[property].length === 0
        }
      }
    },
    // watch the above
    watch: {
      // if the property changes update the state
      [property]: {
        immediate: true,
        handler(property) {
          this.checkbox$toggle(defaultState)
        }
      },
      checkbox$selection(selection) {
        if(selection.length === this[property].length && selection.length > 0) {
          this.checkbox$indeterminate = false
          this.checkbox$all = true
        } else if(selection.length === 0) {
          this.checkbox$indeterminate = false
          this.checkbox$all = false
        } else {
          this.checkbox$indeterminate = true
          this.checkbox$all = false
        }

        this.$emit('selection-changed', selection)
      }
    },
    methods: {
      checkbox$toggle(checked) {
        if(!checked) {
          this.checkbox$selection = []
        } else {
          this.checkbox$selection = _.map(this[property], element => element[key])
        }
      }
    }
  }
}